import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';

import { Heading, Row, InitialAvatarIcon } from '@warrenbrasil/nebraska-web';
import { CustomerModule } from '@/modules/common/store/CustomerModule';

import {
  PortfolioAboutData,
  PortfolioPaidEventConfigurationForm
} from '@/modules/wealth/services/portfolio';

interface Props {
  aboutData: PortfolioAboutData;
  paidEventsConfiguration: PortfolioPaidEventConfigurationForm | null;
}
interface Emit {
  (e: 'toggle-configuration-modal'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutLinks',
  props: {
    aboutData: null,
    paidEventsConfiguration: null
  },
  emits: ["toggle-configuration-modal"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'toggle-configuration-modal'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  aboutData: PortfolioAboutData;
  paidEventsConfiguration: PortfolioPaidEventConfigurationForm | null;
}



const route = useRoute();


const portfolioId = computed(() => {
  return route.params.portfolioId;
});

const showConfigurationButton = computed(() => {
  return props.paidEventsConfiguration !== null;
});

const openConfigurationModal = () => {
  emit('toggle-configuration-modal');
};

const faqRoute = computed(() => {
  if (props.aboutData?.faq?.id) {
    return {
      name: 'help-center-section',
      params: {
        id: props.aboutData.faq.id
      }
    };
  }
  return { name: 'help-center' };
});

const isCustomerPJ = computed(() => {
  return !!CustomerModule?.getCustomer?.professionalProfile;
});

const showIncomeTax = computed(() => {
  return !isCustomerPJ.value && !CustomerModule?.isImpersonated;
});

return { __sfc: true,props, route, emit, portfolioId, showConfigurationButton, openConfigurationModal, faqRoute, isCustomerPJ, showIncomeTax, Heading, Row, InitialAvatarIcon }
}

})